import { Routes } from '@angular/router';
import { Home } from './pages/home/home';
import { Register } from './pages/register/register';
import { Login } from './pages/login/login';
import { ForgotPassword } from './pages/forgot-password/forgot-password';
import { ResetPassword } from './pages/reset-password/reset-password';
import { VerifyEmail } from './pages/verify-email/verify-email';
import { Terms } from './pages/legal/terms/terms';
import { Privacy } from './pages/legal/privacy/privacy';
import { CompetitionList } from './pages/competitions/competition-list/competition-list';
import { CompetitionNew } from './pages/competitions/competition-new/competition-new';
import { CompetitionDetail } from './pages/competitions/competition-detail/competition-detail';
import { CompetitionPicks } from './pages/competitions/competition-picks/competition-picks';
import { CompetitionLeaderboard } from './pages/competitions/competition-leaderboard/competition-leaderboard';
import { CompetitionAchievements } from './pages/competitions/competition-achievements/competition-achievements';
import { Join } from './pages/join/join';
import { AdminDashboard } from './pages/admin/admin-dashboard/admin-dashboard';
import { AdminPeopleList } from './pages/admin/admin-people-list/admin-people-list';
import { AdminCompetitionsList } from './pages/admin/admin-competitions-list/admin-competitions-list';
import { AdminUsersList } from './pages/admin/admin-users-list/admin-users-list';
import { PlanConfigPage } from './pages/admin/plan-config/plan-config';
import { authGuard } from './core/auth/auth-guard';
import { siteAdminGuard } from './core/auth/site-admin-guard';

export const routes: Routes = [
  { path: '', component: Home },
  { path: 'register', component: Register },
  { path: 'login', component: Login },
  { path: 'forgot-password', component: ForgotPassword },
  { path: 'reset-password', component: ResetPassword },
  { path: 'verify-email', component: VerifyEmail },
  // F-034 — public legal pages; no authGuard, must stay above '**'.
  { path: 'terms', component: Terms },
  { path: 'privacy', component: Privacy },
  { path: 'admin', component: AdminDashboard, canActivate: [authGuard, siteAdminGuard] },
  { path: 'admin/people', component: AdminPeopleList, canActivate: [authGuard, siteAdminGuard] },
  {
    path: 'admin/competitions',
    component: AdminCompetitionsList,
    canActivate: [authGuard, siteAdminGuard],
  },
  { path: 'admin/users', component: AdminUsersList, canActivate: [authGuard, siteAdminGuard] },
  {
    path: 'admin/plan-config',
    component: PlanConfigPage,
    canActivate: [authGuard, siteAdminGuard],
  },
  { path: 'join', component: Join, canActivate: [authGuard] },
  { path: 'join/:code', component: Join, canActivate: [authGuard] },
  // 'new' must stay ahead of ':id' so it doesn't get swallowed as an id.
  { path: 'competitions/new', component: CompetitionNew, canActivate: [authGuard] },
  { path: 'competitions', component: CompetitionList, canActivate: [authGuard] },
  { path: 'competitions/:id/picks', component: CompetitionPicks, canActivate: [authGuard] },
  {
    path: 'competitions/:id/leaderboard',
    component: CompetitionLeaderboard,
    canActivate: [authGuard],
  },
  {
    path: 'competitions/:id/achievements',
    component: CompetitionAchievements,
    canActivate: [authGuard],
  },
  { path: 'competitions/:id', component: CompetitionDetail, canActivate: [authGuard] },
  { path: '**', redirectTo: '' },
];
